import { actionCreator } from '@ardoq/rxbeach';

export const bypassLimit = actionCreator('[dependencyMap v2] BYPASS_LIMIT');
